/**
 * Forward step within the program-matching sub-flow that goToNextStep advances
 * (the list → next branch is selection-driven and lives in the rules engine's
 * `selectProgram`). Returns null when `fromPath` isn't a program step, so the
 * caller falls back to the state-derived route.
 *
 *   coaching-method → full-choice-program-review
 */
export function programMatchingNextStep(fromPath: string | null): string | null {
  switch (fromPath) {
    case '/step/coaching-method-screen':
      return '/step/full-choice-program-review-screen';
    default:
      return null;
  }
}
